import { Link } from 'react-router-dom';
import './SearchResults.scss'
import { Rating } from '../Rating/Rating';
import { convertToHours } from '../../utils/utils';
import noImg from '../../assets/img/no-img.webp'
import { IMovies } from '../../models/IMovies';
import { FC } from 'react';

interface SearchResultsProps {
    movieSearch: IMovies
    setSearchParam: (value: string) => void
    setSearchVisible: (value: boolean) => void
}

export const SearchResults: FC<SearchResultsProps> = ({ setSearchVisible, movieSearch, setSearchParam }) => {


    const handleClick = () => {
        setSearchParam(''); // Очищаем поиск, можно убрать если не нужно
        setSearchVisible(false); // Скрываем поиск
      };

    return (
        <Link onClick={handleClick} className='search-result__link' to={`/movie/${movieSearch.id}`}>
            <img className='search-result__img' src={movieSearch.posterUrl !== null ? movieSearch.posterUrl : noImg} alt={movieSearch.title} />
            <div className='search-result__dscr'>
                <div className='search-result__block'>
                    <Rating rating={movieSearch.tmdbRating} ratingClass='rating rating_search' starClass='rating__star rating__star_search' spanClass='rating__number rating__number_search' />
                    <span className='search-result__year'>{movieSearch.releaseYear}</span>
                    <span className='search-result__genre'>{movieSearch.genres[0]}</span>
                    <span className='search-result__runtime'>{convertToHours(movieSearch.runtime)}</span>
                </div>
                <div className='search-result__block'>
                    <span className='search-result__title'>{movieSearch.title}</span>
                </div>
            </div>
        </Link>
    )
}